import React, { useEffect } from 'react';
import Header from '../components/Header';
import ContactSection from '../components/Contact';
import Footer from '../components/Footer';
import Seo from '@/components/Seo';

function Contact() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="App">
      <Seo
        title="İletişim - Tilki Otomasyon"
        description="Tilki Otomasyon ile iletişime geçin. Mevcut müşterilere 7/24 destek. Demo ve abonelik başvurularına hafta içi 09:00–18:00 arasında dönüş sağlanır."
        path="/iletisim"
      />
      <Header />
      <main id="main-content">
        <h1 className="sr-only">Tilki Otomasyon İletişim</h1>
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default Contact;
